import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { Keyword, User } from '../../../_models';
import { KeywordService, AuthenticationService, NotificationService, SpiderService, EnvService, UserService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { KeyValuePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

@Component({ templateUrl: './keyword-list.component.html' })
export class KeywordListComponent implements OnInit {
  filterForm: FormGroup;
  newKeywordForm: FormGroup;
  keywords: Keyword[];
  currentUser: User;
  sourceList = {};
  filterSourceList = [];
  // typeList = {};
  reminderPeriodList = [];
  countryList: any = [];
  filterCountryList: any = {};
  intervalList = {};
  categoryList = [];
  operatorList: any = {};
  filterOperatorList: any = [];
  keywordList: any = [];
  filterKeywordList: any = [];
  shortCodeList = [];
  filterShortCodeList = [];
  clientList: any = [];
  loading = false;
  processing = false;
  showError = false;
  itemsPerPage = 10;
  pagingList = [10, 20, 40, 60, 80, 100];
  totalItems = 0;
  maxSize = 11;
  numPages = 0;
  currentPage = 1;
  page: number;
  goToPage: number;
  emptyResult = false;
  maxPageSize: number;
  spiderAccountList: any = [];
  allSpiderAccountList: any = [];

  exporting = false;
  downloadUrl = '';

  initialized = false;

  filterable = {
    // type: '',
    shortCode: null,
    keyword: null,
    operator: null,
    source: null,
    country: null,
    managerName: ''
  };

  allShortCodes = [];
  targetShortCode = null;

  backSource = null;
  backCountry = null;
  backOperator = null;
  backShortCode = null;
  backKeyword = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private userSvc: UserService,
    private envSvc: EnvService,
    private authSvc: AuthenticationService,
    private keywordSvc: KeywordService,
    private spiderSvc: SpiderService,
    private notification: NotificationService,
    private modalService: NgbModal) {

    this.currentUser = this.authSvc.currentUserValue;
  }

  ngOnInit(): void {
    this.backSource = this.route.snapshot.paramMap.get('source');
    this.backCountry = this.route.snapshot.paramMap.get('country');
    this.backOperator = this.route.snapshot.paramMap.get('operator');
    this.backShortCode = this.route.snapshot.paramMap.get('shortCode');
    this.backKeyword = this.route.snapshot.paramMap.get('keyword');

    // clear path parameter
    this.router.navigate(['/dashboard/keyword']);

    this.loadAllShortCodes();
    this.loadSelectionSources();
    // this.loadKeywordTypes();
    this.loadClients();
    this.loadAllCategories();
    if (this.backSource == null) {
      this.loadPage(1);
    }
  }

  openModal(targetModal, keyword = null) {
    if (this.initialized == false) {
      this.loadAllSources();
      this.loadAllCountries();
      this.loadIntervals();
      this.loadSpiderAccount();
      this.loadReminderPeriod();
      this.initialized = true;
    }

    this.processing = false;
    this.showError = false;
    this.modalService.open(targetModal, {
      windowClass: 'modal-holder',
      size: 'lg'
    });

    this.newKeywordForm = this.fb.group({
      shortCode: [null, Validators.required],
      keyword: ['', Validators.required],
      operator: ['', Validators.required],
      country: ['', Validators.required],
      source: ['', Validators.required],
      price: ['', Validators.required],
      // type: ['', Validators.required],
      category: [1, Validators.required],
      interval: ['', Validators.required],
      schedules: ['', Validators.required],
      moMin: [0, Validators.required],
      moCap: [0, Validators.required],
      moNotifyUrl: [''],
      cnvMin: [0, Validators.required],
      cnvCap: [0, Validators.required],
      cnvUrl: [''],
      dnMin: [0, Validators.required],
      dnCap: [0, Validators.required],
      dnNotifyUrl: [''],
      managerId: [''],
      share: [''],
      premiumService: [''],
      affiliateFromClick: [0, Validators.required],
      spiderAccountId: [''],
      moPostBackRate: [100, Validators.required],
      dnPostBackRate: [100, Validators.required],
      cnvPostBackRate: [100, Validators.required],
      affiliateEnabled: [false, Validators.required],
      affiliateClickEnabled: [false, Validators.required],
      reminderPeriod: [''],
      revenueShareRatio: [''],
    });
    this.operatorList = [];
    this.shortCodeList = [];
    this.keywordList = [];
  }

  get f() { return this.newKeywordForm.controls; }

  search(): void {
    this.totalItems = 0;
    this.loadPage(1);
  }

  clear(): void {
    this.filterable = {
      // type: '',
      shortCode: null,
      keyword: null,
      operator: null,
      source: null,
      country: null,
      managerName: ''
    };
    this.filterCountryList = {};
    this.filterOperatorList = [];
    this.filterShortCodeList = [];
    this.filterKeywordList = [];
    this.targetShortCode = null;
  }

  onClear(): void {
    this.targetShortCode = null;
    this.filterable.shortCode = null;
    this.filterable.keyword = null;
    this.keywordList = {};
  }

  setPage(pageNo: number): void {
    this.currentPage = pageNo;
    this.loadPage();
  }

  pageChanged(event: any): void {
    this.page = event.page;
    if (this.page != this.currentPage) {
      this.loadPage(this.page);
    }
  }

  itemsPerPageChange(deviceValue) {
    this.itemsPerPage = deviceValue;
    this.loadPage(1);
  }

  onSubmit() {
    this.processing = true;
    var newDataParam = this.newKeywordForm.getRawValue();
    newDataParam.country = newDataParam.country.code;
    if (this.newKeywordForm.valid) {

      if (confirm("Are you sure to add the keyword now?")) {
        this.keywordSvc.addKeyword(newDataParam).subscribe(data => {
          if (data !== null) {
            if (data.status == 1) {
              this.notification.showSuccess("Keyword added successfully!", "New Keyword");
              this.modalService.dismissAll();
              this.loadSelectionSources(false);
              this.loadAllShortCodes(newDataParam);
            } else {
              this.notification.showError(data.msg, "Fail to add");
            }
          } else {
            this.notification.showError("Failed to add keyword, please try again later.", "Fail to add");
          }
        })
      }
      this.processing = false;
    } else {
      this.showError = true;
      this.notification.showError("Some fields are missing", "Add failed");
      this.processing = false;
    }
  }

  deleteKeyword(keyword) {
    if (confirm("Are you sure to delete this keyword?")) {
      this.keywordSvc.deleteKeyword(keyword.id).subscribe(data => {
        if (data.status == 1) {
          this.notification.showSuccess("Keyword deleted successfully!", "Delete Keyword");
          this.loadPage(1);
        } else {
          this.notification.showError("Error deleting keyword, please try again later.", "Error");
        }
      })
    }
  }

  gotoTargetShortCode(targetShortCode) {
    if (targetShortCode) {
      let source = this.filterSourceList.find(it => { return it.value == targetShortCode.source });
      this.changeFilSource(source, targetShortCode);
    }
  }

  changeFilSource(source, targetShortCode = null, fromBack = false) {
    if (!targetShortCode) {
      this.targetShortCode = null;
    }
    this.filterable.source = source;
    this.filterable.shortCode = null,
      this.filterable.keyword = null,
      this.filterable.operator = null,
      this.filterable.country = null;
    this.filterOperatorList = {};
    this.filterShortCodeList = [];
    this.filterKeywordList = [];
    if (source) {
      this.filterCountryList = source.subOptions;
      if (targetShortCode) {
        this.changeFilCountry(targetShortCode.country, targetShortCode);
      } else if (fromBack && this.backCountry != null) {
        this.changeFilCountry(this.backCountry, null, true);
      }
    }
  }

  changeFilCountry(country, targetShortCode = null, fromBack = false) {
    if (!targetShortCode) {
      this.targetShortCode = null;
    }
    this.filterable.country = country;
    this.filterable.shortCode = null,
      this.filterable.keyword = null,
      this.filterable.operator = null
    this.filterShortCodeList = [];
    this.filterKeywordList = [];
    if (country) {
      this.keywordSvc.getSelectionShortCodes(this.filterable.source.value, country).subscribe(data => {
        this.filterOperatorList = data.data;
        if (targetShortCode) {
          this.changeFilOperator(targetShortCode.operator, targetShortCode);
        } else if (fromBack && this.backOperator != null) {
          this.changeFilOperator(this.backOperator, null, true);
        }
      });
    }
  }

  changeFilOperator(operator, targetShortCode = null, fromBack = false) {
    if (!targetShortCode) {
      this.targetShortCode = null;
    }
    this.filterable.operator = operator;
    this.filterable.shortCode = null;
    this.filterable.keyword = null;
    this.filterKeywordList = [];
    this.filterShortCodeList = [];
    if (operator) {
      this.filterShortCodeList = this.filterOperatorList[operator];
      if (targetShortCode) {
        this.changeFilShortCode(targetShortCode.shortCode, targetShortCode);
      } else if (fromBack && this.backShortCode != null) {
        this.changeFilShortCode(this.backShortCode, null, true);
      }
    }
  }

  changeFilShortCode(shortCode, targetShortCode = null, fromBack = false) {
    this.filterable.shortCode = shortCode;
    this.filterable.keyword = null;
    if (shortCode) {
      this.keywordSvc.getSelectionKws(this.filterable.operator, shortCode).subscribe(data => {
        this.filterKeywordList = data.data;
      });
    }
    if (!targetShortCode) {
      this.targetShortCode = this.allShortCodes.find(it => { return this.filterable.source.value == it.source && this.filterable.shortCode == it.shortCode && this.filterable.operator == it.operator });
    }
    if (fromBack) {
      this.loadPage(1);
    }
  }

  changeCountry(country) { //new keyword
    if (this.newKeywordForm.getRawValue().operator) {
      this.newKeywordForm.patchValue({
        operator: '',
      });
    }
    if (country) {
      this.operatorList = country.operators;
    }
  }

  changeAddSource(source) {
    this.spiderAccountList = this.allSpiderAccountList.filter(it => it.source == source);
  }

  private loadAllSources() {
    this.envSvc.getSources().pipe(first()).subscribe(data => {
      this.sourceList = data.data;
    });
  }

  private loadSelectionSources(initialPage: boolean = true) {
    this.keywordSvc.getSelectionSources().pipe(first()).subscribe(data => {
      this.filterSourceList = data.data;
      if (initialPage) {
        if(this.backSource != null){
          this.changeFilSource(this.filterSourceList.find(it => it.value == this.backSource), null, true);
        }
      }
    });
  }

  private loadIntervals() {
    this.envSvc.getIntervalModes().pipe(first()).subscribe(data => {
      this.intervalList = data.data;
    });
    this.envSvc.getIntervalModes().pipe(first()).subscribe(data => {
      this.intervalList = data.data;
    });
  }

  private loadClients() {
    this.userSvc.getAllClients().pipe(first()).subscribe(data => {
      this.clientList = data.data;
    });
  }

  private loadAllCountries() {
    this.envSvc.getCountries().pipe(first()).subscribe(data => {
      this.countryList = data.data;
    });
  }

  private loadSpiderAccount() {
    this.spiderSvc.getAllSpiderAccount().pipe(first()).subscribe(data => {
      this.allSpiderAccountList = data.data;
    });
  }

  private loadReminderPeriod() {
    this.reminderPeriodList = this.envSvc.getReminderPeriods();
  }

  private loadAllShortCodes(keywordData = null) {
    this.keywordSvc.allShortCodeForSelection().pipe(first()).subscribe(data => {
      if (data) {
        this.allShortCodes = data.data;
        if(keywordData != null){
          this.targetShortCode = this.allShortCodes.find(it => { return keywordData.source== it.source && keywordData.shortCode == it.shortCode && keywordData.operator == it.operator });
          this.gotoTargetShortCode(this.targetShortCode);
        }
      }
    });
  }

  private loadAllCategories() {
    this.categoryList = this.envSvc.getKeywordCategories();
  }

  export() {
    this.exporting = true;
    let params = this.formParam();
    this.keywordSvc.export(params)
      .subscribe(res => {
        this.downloadUrl = res.data;
        document.getElementById('download').click();
        this.exporting = false;
      });
  }

  private loadPage(page = null) {
    this.loading = true;
    this.keywords = [];
    let params = this.formParam(page);

    // get page of items from api
    this.keywordSvc.getAll(params).pipe(first()).subscribe(data => {
      if (data !== null) {
        this.loading = false;
        this.emptyResult = false;
        this.totalItems = data.data.total;
        this.keywords = data.data.list;
        this.currentPage = data.data.page + 1;
        this.maxPageSize = Math.ceil(data.data.total / data.data.pageSize) < 1 ? 1 : Math.ceil(data.data.total / data.data.pageSize);
      } else {
        this.loading = false;
        this.emptyResult = true;
        this.maxPageSize = 0;
        this.notification.showWarning("There is no record for this admin.", "Empty Result");
      }
    });
  }

  private formParam(page = null) {
    let params = {
      pageSize: this.itemsPerPage || 20,
      page: page == null ? this.currentPage - 1 : page - 1,
      shortCode: this.filterable.shortCode,
      keyword: this.filterable.keyword == null ? "" : this.filterable.keyword.keyword,
      operator: this.filterable.operator,
      country: this.filterable.country,
      source: this.filterable.source == null ? "" : this.filterable.source.value,
      // type: this.filterable.type,
      managerName: this.filterable.managerName,
    }
    return params;
  }

}
